"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isDate = isDate;
exports.isFunction = isFunction;
exports.isNumber = isNumber;
exports.isObject = isObject;
exports.isString = isString;
exports.isUndefined = isUndefined;
function isDate(value) {
    return Object.prototype.toString.call(value) === '[object Date]';
}

function isFunction(value) {
    return typeof value === "function";
}

function isNumber(value) {
    return typeof value === "number" && isFinite(value);
}

function isObject(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && !Array.isArray(value);
}

function isString(value) {
    return typeof value === "string";
}

function isUndefined(value) {
    return typeof value === "undefined";
}
//# sourceMappingURL=utils.js.map